var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7779_43744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67947 1.86259C8.90302 1.52825 8.06185 1.36225 7.21178 1.37867C6.15008 1.39918 5.11322 1.70351 4.20885 2.26004C3.30447 2.81658 2.56554 3.60505 2.06878 4.54359C1.57203 5.48214 1.33554 6.53655 1.38388 7.59735C1.43222 8.65813 1.76362 9.68666 2.34368 10.5761C3.37951 12.1645 3.99277 12.7484 3.99277 14.6386C3.99277 14.8139 4.0624 14.9821 4.18636 15.106C4.31033 15.23 4.47845 15.2996 4.65375 15.2996H9.99933C10.1746 15.2996 10.3428 15.23 10.4667 15.106C10.5907 14.9821 10.6603 14.8139 10.6603 14.6386C10.6603 12.9473 11.184 12.2951 12.0025 11.0593",
    stroke: "#747787",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51245 18.6224H9.14041",
    stroke: "#747787",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5328 3.57915C13.1833 2.92866 13.284 2.33192 13.7566 1.7306C14.1264 1.25989 14.8268 1.25989 15.1967 1.7306C15.6693 2.33192 15.77 2.92866 16.4205 3.57915C17.0709 4.22964 17.6677 4.33034 18.2691 4.80289C18.7397 5.17281 18.7397 5.87314 18.2691 6.24305C17.6677 6.7156 17.0711 6.81631 16.4205 7.46679C15.77 8.11728 15.6693 8.71402 15.1968 9.31535C14.8268 9.78606 14.1266 9.78606 13.7566 9.31535C13.2841 8.71402 13.1834 8.11728 12.5329 7.46679C11.8824 6.8163 11.2857 6.7156 10.6843 6.24305C10.2136 5.87314 10.2136 5.17281 10.6843 4.80289C11.2857 4.33034 11.8824 4.22963 12.5328 3.57915Z",
    stroke: "#747787",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7779_43744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.24598e433423090de59438e9e9ec24df.svg";
export { ForwardRef as ReactComponent };